import React, { useEffect, useState } from "react";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import "../../Assets/Css/ShareHolders.scss";
import { Link, useNavigate } from "react-router-dom";
import UserAvatar from "react-user-avatar";
import { BiPhoneCall } from "react-icons/bi";
import { HiOutlineMail } from "react-icons/hi";
import { connect } from "react-redux";
import { getShareholders, getShareholdersGroupsList } from "../../Services/Shareholders/action";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const ShareHoldersGroup = (props) => {
    const navigate = useNavigate();
    let path = "/shareholder/group/add";
    const [shareholderData, setShareholderData] = useState([]);
    const [shareholdersgroupslist, setShareHoldersGroupslist] = useState([]);
    const [shareholdersgroupsmaplist, setShareHoldersGroupsMaplist] = useState([]);
    const [groupedShareholders, setGroupedShareholders] = useState({});
    const [unassignedAmount, setUnassignedAmount] = useState(0);
    let unsignedAmount = 0;
    let assignedAmount = 0;
    const [isSharePercentageLessThan100, setIsSharePercentageLessThan100] = useState(false);
    const [xyz, setXyz] = useState({});


    useEffect(() => {
        fetchShareHolderData();
        fetchShareHoldersGroupsData();
        fetchShareHoldersGroupsMapData();
    }, []);

    useEffect(() => {
        setTheData();
        setTheGroupsData();
        setTheGroupsMapData();
    }, [props.shareholders, props.shareholdersgroupslist, props.shareholdersgroupslist?.shareHoldersGroupsMap]);


    const fetchShareHolderData = async () => {
        try {
            await props.getShareholders();
            setTheData();
        } catch (error) {
            toast.error(error);
        }
    };

    const fetchShareHoldersGroupsData = async () => {
        try {
            await props.getShareholdersGroupsList();
            setTheGroupsData();
        } catch (error) {
            toast.error(error);
        }
    };

    const fetchShareHoldersGroupsMapData = async () => {
        try {
            await props.getShareholdersGroupsList();
            setTheGroupsMapData();
        } catch (error) {
            toast.error(error);
        }
    };

    const setTheData = async () => {
        try {
            console.log(props, ' <== setting up...shareholderData')
            // ((await props?.shareholders) &&
            setShareholderData(await props?.shareholders);
            console.log(shareholderData, ' <== shareholderData');
            props?.shareholders?.forEach((sh) => {
                assignedAmount += parseFloat(sh?.balance);
            });

            setUnassignedAmount(parseFloat((parseFloat(totalUnAssigned)).toFixed(2)));
        } catch (error) {
            toast.error(error);
        }
    };

    const setTheGroupsData = async () => {
        try {
            ((await props.shareholdersgroupslist?.shareHoldersGroups) &&
                setShareHoldersGroupslist(await props.shareholdersgroupslist?.shareHoldersGroups));
            console.log(shareholdersgroupslist, ' <== shareHoldersGroupslist');
        } catch (error) {
            toast.error(error);
        }
    };

    const setTheGroupsMapData = async () => {
        try {
            const shareholderGroupMap = await props.shareholdersgroupslist?.shareHoldersGroupsMap;
            if (!shareholderGroupMap) return;

            const groupedShareholders = {};

            shareholderGroupMap.forEach(groupMap => {
                const { shareholder_id, group_id } = groupMap;
                const shareholder = props.shareholders.find(sh => sh.id === shareholder_id);

                if (shareholder) {
                    if (!groupedShareholders[group_id]) {
                        groupedShareholders[group_id] = [];
                    }
                    groupedShareholders[group_id].push(shareholder);

                }
            });

            setGroupedShareholders(groupedShareholders);
            console.log(groupedShareholders, ' <== groupedShareholders');
            const z = shareholdersgroupslist.map((i) => i.id);
            const newXYZ = {};

            z.forEach(groupId => {
                const shareholdersInGroup = groupedShareholders[groupId] || [];
                const sharePercentages = shareholdersInGroup.map(sh => {
                    const sharePercentage = sh.shareHolderGroups.find(group => group.group_id === groupId)?.share_percentage || '0.00';
                    return parseFloat(sharePercentage).toFixed(2); // Convert to float and fix to 2 decimal places
                });
                const sum = sharePercentages.reduce((total, percentage) => total + parseFloat(percentage), 0).toFixed(2);
                newXYZ[groupId] = {
                    sum: sum
                };
            });

            setXyz(newXYZ);

            ((await props.shareholdersgroupslist?.shareHoldersGroupsMap) &&
                setShareHoldersGroupsMaplist(await props.shareholdersgroupslist?.shareHoldersGroupsMap));
        } catch (error) {
            toast.error(error);
        }
    };

    const handleAddClick = () => {
        navigate(path);
    };

    return (
        <Sidebarlayout>
            <div className="main-shareholder">
                <div className="page-title">
                    <h4>Share Holders Groups</h4>
                    <div className="edit-btn">
                        <button
                            className="custom-btn"
                            disabled={props.loading}
                            onClick={handleAddClick}
                        >
                            {props.loading ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            ) : (
                                "Add"
                            )}
                        </button>
                    </div>
                </div>
                <div className="content-part">
                    {props.loading ? (
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        </div>
                    ) : (
                        <div className="row custom-row">
                            {shareholdersgroupslist
                                ? shareholdersgroupslist?.map((sholder, index) => {
                                    let data = { shId: sholder?.id };
                                    const isGroupSharePercentageLessThan100 = xyz[sholder?.id]?.sum < 99.99;

                                    return sholder?.is_category !== true ? (
                                        <div
                                            key={sholder?.id}
                                            className="col-xl-4 col-lg-6 custom-col"
                                        >
                                            <div className="shareholder-card" style={{ backgroundColor: isGroupSharePercentageLessThan100 ? 'rgba(255, 0, 0, 0.08)' : '' }}>
                                                <div className="shareholder-image-block">
                                                    <UserAvatar
                                                        size="100"
                                                        src={""}
                                                        name={sholder?.name || "-"}
                                                    />
                                                </div>
                                                <div className="shareholder-content-block">
                                                    <h6 className="sh-name">

                                                        {sholder?.name || "unknown"}
                                                    </h6>
                                                </div>
                                                {Array.isArray(groupedShareholders[sholder?.id]) && groupedShareholders[sholder?.id].length > 0 ? (
                                                    groupedShareholders[sholder?.id].map((sh, index) => (
                                                        <>
                                                            <div key={index}>
                                                                <h6 className="sh-role">{sh.name}</h6>
                                                            </div>

                                                        </>
                                                    ))
                                                ) : (
                                                    <p>No Shareholders in this group</p>
                                                )}
                                                <div className="shareholder-balance-block">
                                                    <h6 className="sh-balance">
                                                        ₹{sholder?.balance}
                                                    </h6>
                                                </div>
                                                <div className="action-block">
                                                    <Link to="/shareholder/group/view" state={{ data: groupedShareholders, sholderId: data.shId }}>
                                                        <button className="custom-btn">View</button>
                                                    </Link>
                                                    <Link to="/shareholder/group/edit" state={{
                                                        data: shareholdersgroupslist,
                                                        groupedShareholders: groupedShareholders, sholderId: data.shId,
                                                        shdata: shareholderData
                                                    }}>
                                                        <button className="custom-btn">Edit</button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null;
                                })
                                : "No Records"}
                        </div>
                    )}
                </div>
            </div>
        </Sidebarlayout>
    );
};

export const mapStateToProps = (state) => {
    return {
        shareholders: state.shareholdersReducer.shareholders.rows,
        count: state.shareholdersReducer.shareholders.count,
        totalBalance: state.shareholdersReducer.shareholders.totalBalance,
        totalUnAssigned: state.shareholdersReducer.shareholders.totalUnAssigned,
        loading: state.shareholdersReducer.loading,
        shareholdersgroupslist: state.shareholdersReducer.shareholdersgroupslist,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        getShareholders: (params) => {
            dispatch(getShareholders(params));
        },
        getShareholdersGroupsList: () => {
            dispatch(getShareholdersGroupsList());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareHoldersGroup);
